import React from 'react'
import { HashRouter, Route, Routes } from 'react-router-dom'
import './scss/fontawesome/css/font-awesome.min.css'
import './scss/style.scss'
// import { useSelector } from 'react-redux'
import MaintenancePage from './views/pages/MaintenancePage/MaintenancePage'



const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
// const Login = React.lazy(() => import('./views/pages/login/Login'))
// const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
// const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))
// const PageThankyou = React.lazy(() => import('./views/pages/pageThankyour/thank_you'))
// const Closed = React.lazy(() => import("./views/pages/Closed"))

function App() {
  // const getLogin = useSelector((state) => state.login.result)
  return (
    <HashRouter>
      <React.Suspense fallback={loading} >
        <Routes>
          {/* <Route exact path="/login" name="Login Page" element={ <Login  />} /> */}
          {/* <Route exact path="/404" name="Page 404" element={ <Page404  />} />
          <Route exact path="/500" name="Page 500" element={<Page500  />} />
          <Route exact path="/thankyou" name="Thank you" element={ <PageThankyou />} />
          <Route path="*" name="Home" element={<DefaultLayout  />} /> */}
          <Route path="*" name="Home" element={<MaintenancePage  />} />
          {/* <Route
            path="/"
            name="Home"
            render={(props) =>
              getLogin === null ? <Login {...props} />
                :
                <DefaultLayout {...props} />
            }
          /> */}

        </Routes>
      </React.Suspense>
    </HashRouter>
  )
}
export default App
